(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-with-text-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('images-with-text-scroll')) {
    class ImagesWithTextScroll extends HTMLElement {
      connectedCallback() {
        this.images = this.querySelectorAll('.iwts__image');
        this.items = this.querySelectorAll('.iwts__item');
        if (!this.images.length || !('IntersectionObserver' in window)) return;

        // Aktiverer det billede, hvis tekst krydser midten af skærmen
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(entry.target.dataset.index);
            });
          },
          { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
        );

        this.items.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      setActive(index) {
        this.images.forEach((image) => {
          image.classList.toggle('is-active', image.dataset.index === index);
        });
      }
    }

    customElements.define('images-with-text-scroll', ImagesWithTextScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-content')) {
    class ScrollingContent extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sc__track');
        this.group = this.querySelector('.sc__group');
        if (!this.track || !this.group) return;

        this.setup = this.setup.bind(this);
        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(this.setup, 100);
        });
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);

        // Pause båndet, mens en blok er valgt i theme editoren
        this.onBlockSelect = (event) => {
          if (this.contains(event.target)) this.classList.add('is-paused');
        };
        this.onBlockDeselect = (event) => {
          if (this.contains(event.target)) this.classList.remove('is-paused');
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.setup();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      setup() {
        // Fjern gamle kopier
        this.track.querySelectorAll('.sc__group--clone').forEach((clone) => clone.remove());

        const groupWidth = this.group.offsetWidth;
        if (!groupWidth) return;

        // Nok kopier til at dække skærmen, plus én ekstra, så loopet er sømløst
        const copies = Math.ceil(this.offsetWidth / groupWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.classList.add('sc__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('*').forEach((el) => {
            [...el.attributes].forEach((attr) => {
              if (attr.name.startsWith('data-shopify')) el.removeAttribute(attr.name);
            });
            if (el.tagName === 'A') el.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(clone);
        }

        // Hastighed: 0.1–2, hvor 1 svarer til 200px pr. sekund
        const speed = parseFloat(this.dataset.speed) || 0.3;
        const pixelsPerSecond = speed * 200;

        this.style.setProperty('--sc-shift', `-${groupWidth}px`);
        this.style.setProperty('--sc-duration', `${groupWidth / pixelsPerSecond}s`);
        this.classList.add('is-ready');
      }
    }

    customElements.define('scrolling-content', ScrollingContent);
  }

  } catch(e) { console.error(e); }
})();
})();
